module.exports = __webpack_public_path__ + "static/img/banner-cursos-interior-1024x768.e25384f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/@banners/@responsive/search-cursos/banner-cursos-interior-1024x768.jpg
// module id = Y6E0
// module chunks = 47